/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './atendant.reducer';

export const AtendantDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const atendantEntity = useAppSelector(state => state.atendant.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="atendantDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.atendant.detail.title">Atendant</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.atendant.id">Id</Translate>
            </span>
          </dt>
          <dd>{atendantEntity.id}</dd>
          <dt>
            <span id="phone">
              <Translate contentKey="tinyMedicRestApp.atendant.phone">Phone</Translate>
            </span>
          </dt>
          <dd>{atendantEntity.phone}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.atendant.name">Name</Translate>
            </span>
          </dt>
          <dd>{atendantEntity.name}</dd>
          <dt>
            <span id="orderOfPriority">
              <Translate contentKey="tinyMedicRestApp.atendant.orderOfPriority">Order Of Priority</Translate>
            </span>
          </dt>
          <dd>{atendantEntity.orderOfPriority}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.atendant.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{atendantEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.atendant.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{atendantEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.atendant.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{atendantEntity.lastupdated}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.atendant.active">Active</Translate>
            </span>
          </dt>
          <dd>{atendantEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.atendant.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{atendantEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.atendant.glucoUser">Gluco User</Translate>
          </dt>
          <dd>{atendantEntity.glucoUser ? atendantEntity.glucoUser.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.atendant.admission">Admission</Translate>
          </dt>
          <dd>{atendantEntity.admission ? atendantEntity.admission.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/atendant" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/atendant/${atendantEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default AtendantDetail;
